import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import {
  DashboardResponse,
  OauthAEMConfig,
  PkceCode
} from '../../../../models/login';
import { LoginRememberMeUtilsService } from '../../../../utils/login';
import { CookieHelperService, LoggingService } from '../../../utils';
import { LoginRememberMeWrapperService } from '../../wrappers/login-remember-me-wrapper.service';
import { UserDataService } from './user-data/user-data.service';

@Injectable({
  providedIn: 'root'
})
export class UserSessionHelperExtendedService {
  protected userData = inject(UserDataService);
  protected loginRememberMeWrapper = inject(LoginRememberMeWrapperService);
  protected logging = inject(LoggingService);
  protected loginRememberMeUtils = inject(LoginRememberMeUtilsService);
  protected cookieHelper = inject(CookieHelperService);
  protected data$!: Observable<DashboardResponse>;

  pkceCode = {} as PkceCode;
  tokenAvailable = false;
  tokenExpiry = 0;
  tokenIssuedTime = 0;
  tokenValue$: BehaviorSubject<boolean> = new BehaviorSubject(false);

  removeSessionValues(): void {
    if (
      window.localStorage.getItem('uid') ||
      window.localStorage.getItem('encyToken') ||
      this.cookieHelper.getCookieValue('accountType')
    ) {
      window.localStorage.removeItem('uid');
      window.localStorage.removeItem('encyToken');
      this.cookieHelper.setCookieName('accountType', '', 0, false);
    }
  }

  registerServiceWorker(response: OauthAEMConfig): void {
    if (!('serviceWorker' in navigator)) return;

    const origin = window.location.origin;
    const modifiedOrigin = origin.replace(/^https?:\/\//, '');
    const scope = modifiedOrigin.split('/')[0];

    if (response?.ENABLE_NEW_PERSISTENT_LOGIN) {
      this.registerNewServiceWorker(response, scope);
    } else {
      this.unregisterServiceWorkers();
    }
  }

  registerNewServiceWorker(response: OauthAEMConfig, scope: string): void {
    if (!response.REGISTER_SW_URL) return;

    navigator.serviceWorker
      .register(response.REGISTER_SW_URL, {
        scope: `https://${scope}`,
        updateViaCache: 'none'
      })
      .then(() => navigator.serviceWorker.ready)
      .catch((e) =>
        this.logging.log(`Service worker registration failed: ${e}`)
      );
  }

  unregisterServiceWorkers(): void {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => {
        registration.unregister();
        this.logging.log('Service workers have been unregistered');
        window.location.reload();
      });
    });
  }
}
